export default {
  get name(): string {
    return 'ExponentSecureStore';
  },
  async getValueWithKeyAsync(): Promise<null> {
    return null;
  },
};
